/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cus_SuccessInputs */

const en_ticket_action_cus_success = /** @type {(inputs: Ticket_Action_Cus_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just-Go visit reported as unsuccessful.`)
};

const ja_ticket_action_cus_success = /** @type {(inputs: Ticket_Action_Cus_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just-Go訪問は不成功と報告しました。`)
};

const fr_ticket_action_cus_success = /** @type {(inputs: Ticket_Action_Cus_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visite Just-Go signalée comme non réussie.`)
};

const de_ticket_action_cus_success = /** @type {(inputs: Ticket_Action_Cus_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just-Go-Besuch als nicht erfolgreich gemeldet.`)
};

/**
* | output |
* | --- |
* | "Just-Go visit reported as unsuccessful." |
*
* @param {Ticket_Action_Cus_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cus_success = /** @type {((inputs?: Ticket_Action_Cus_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cus_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cus_success(inputs)
	if (locale === "ja") return ja_ticket_action_cus_success(inputs)
	if (locale === "fr") return fr_ticket_action_cus_success(inputs)
	return de_ticket_action_cus_success(inputs)
});